<template>
   <iframe
      src="/landing/index.html"
      style="width:100%; height:100vh; border:none;"
    />
</template>

<script>
export default {
  name: "LandingView",
mounted() {
    this.$el.addEventListener('click', (e) => {
      const anchor = e.target.closest('a');

      if (!anchor) return;

      const href = anchor.getAttribute('href');

      if (href && href.startsWith('/')) {
        e.preventDefault();

        console.log('navegando a', href);

        this.$router.push(href);
      }
    });
  }
}
</script>